
import React, { ChangeEvent, useEffect, useRef, useState } from "react";

import _, { set } from 'lodash';
import cx from 'classnames';
import styles from './styles.module.scss'

export interface ITag {
  item: string,
  highlight: boolean,
}

interface TagsInputProps {
  handleTagValuesUpdate: (tags: string[]) => void;
  selectedTags: string[];
  className?: string
}

export const TagsInput: React.FC<TagsInputProps> = ({ selectedTags, handleTagValuesUpdate, className }) => {

  const [tagsInput, setTagsInput] = useState("");
  const [tags, setTags] = useState<ITag[]>([]);
  const [trigger, setTrigger] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const updatedTags = selectedTags.map((tag: string) => {
      return {
        item: tag,
        highlight: false
      }
    })
    setTags(updatedTags);
  }, [selectedTags])

  const handleTagsInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTagsInput(e.target.value);
  };

  const handleTagUpdate = (tags) => {
    const extractedTags = _.map(tags, "item");
    handleTagValuesUpdate(extractedTags);
  }

  const handleTagsKeyDown = (e: any) => {
    if (_.size(tags) == 0 && tagsInput.length == 0) {
      return;
    }
    if (e.keyCode === 13) {
      //Enter
      if (tagsInput.length > 0) {
        if(_.find(tags, { item: tagsInput })) {
          setTagsInput("");
          return;
        }

        const updatedTags = [...tags, { item: tagsInput, highlight: false }]
        setTags(updatedTags);
        setTagsInput("");
        handleTagUpdate(updatedTags)
      }
    }

    if (e.keyCode === 8 && tagsInput.length === 0) {
      //Backspace
      var items = tags;
      var highlight = tagsInput.length === 0;
      var lastItem = items[items.length - 1];
      if (!highlight) {
        lastItem.highlight = highlight;
      } else if (lastItem && lastItem.highlight) {
        //delete
        items = items.slice(0, items.length - 1);
        handleTagUpdate(items)
      } else {
        lastItem.highlight = highlight;
      }
      setTags(items);
      setTrigger(!trigger);
    }
  };

  const handleTagClose = (tag: ITag) => {
    const filteredTags = tags.filter((item: ITag) => {
      return item !== tag;
    });

    setTags(filteredTags);
    handleTagUpdate(filteredTags);

  };

  return (
    <div className={cx(styles.tagsContainer, className)}>

      <div className={styles.lists}>
        {tags.map((tag: ITag, index: number) => {
          return (
            <div
              className={cx(styles.list, styles.tagItem, {
                [styles.highlight]: tag.highlight,
              })}
            >
              <Tag className="" tag={tag.item} key={`tag_${index}`} />
              <i
                className="paperflite-close"
                onClick={() => handleTagClose(tag)}
              />
            </div>
          );
        })}

        <input
          ref={inputRef}
          className={styles.inputBox}
          placeholder="type something..."
          type="text"
          value={tagsInput}
          onChange={(e) => handleTagsInputChange(e)}
          onKeyDown={(e) => handleTagsKeyDown(e)}
        />
      </div>

    </div>
  )
}

interface TagProps {
  className: string;
  tag: string;
  onClick?: (tag: string) => void;
}


const Tag = ({ className, tag, onClick }: TagProps) => {
  const handleTagClick = () => {
    if (onClick) {
      onClick(tag);
    }
  };
  return (
    <div className={className} onClick={() => handleTagClick()}>
      <span>{tag}</span>
    </div>
  );
};